import { Button, Title } from '../../components/UI';

import { Container, Content, MoreNews } from '../../styles/pages/news/styles';
import { News as INews } from '../../models/news';
import CarouselNews from '../../components/Carousel/CarouselNews';
import Newscontainer from '../../components/NewsContainer';
import { useNews } from '../../hooks/news';
import { useEffect, useState } from 'react';
import { useRouter } from 'next/router';
import Skeleton from '../../components/Skeleton';
import LoadingMoreNews from '../../components/Shimmer/LoadingMoreNews';
import { AlignButton } from '../../styles/pages/stores/styles';

const News = () => {
  const [news, setNews] = useState<INews[]>([]);
  const [page, setPage] = useState(0);
  const [isLoading, setIsLoading] = useState(true);
  const [isLoadingCarrosel, setIsLoadingCarrosel] = useState(true);
  const [enableShowMore, setEnableShowMore] = useState(false);

  const { getNews } = useNews();
  const router = useRouter();

  useEffect(() => {
    async function getInitialData() {
      try {
        const news = await getNews(page, 10);
        if (news.length >= 10) {
          setEnableShowMore(true);
        }
        setNews(news);
        setIsLoading(false);
        setIsLoadingCarrosel(false);
      } catch (error) {
        setIsLoading(false);
        setIsLoadingCarrosel(false);
        console.log(error);
      }
    }

    if (page == 0) {
      getInitialData();
    }
  }, [getNews, page]);

  const decodeText = (text: string) => {
    return text
      .replace(/&#(\d+);/g, function (match, dec) {
        return String.fromCharCode(dec);
      })
      .replace(/<p>/g, '')
      .replace(/&nbsp;/g, ' ')
      .replace(/<\/p>/g, '');
  };

  const httpTohttps = (url: string) => {
    return url.replace(/http:/g, 'https:');
  };

  const handleClick = (slug: string) => {
    router.push({
      pathname: `news/${slug}`,
    });
  };

  const handleShowMore = async () => {
    try {
      setIsLoading(true);
      const newsData = await getNews(page + 1, 10);
      if (newsData.length < 20) {
        setEnableShowMore(false);
      }
      setNews([...news, ...newsData]);
      setPage(page + 1);
      setIsLoading(false);
    } catch (error) {
      console.log(error);
      setIsLoading(false);
    }
  };

  return (
    <Container>
      <Content>
        <div className="Left">
          {isLoadingCarrosel ? <Skeleton className="row" /> : <CarouselNews />}
        </div>
        <div className="Right">
          {isLoadingCarrosel ? (
            <div>
              <Skeleton className="row" />
              <Skeleton className="row" />
              <Skeleton className="row" />
              <Skeleton className="row" />
            </div>
          ) : (
            news.slice(0, 4).map((newsItem, index) => (
              <div key={index}>
                <h2 onClick={() => handleClick(newsItem.slug)}>
                  {' '}
                  {decodeText(newsItem.title)}
                </h2>{' '}
                <br />
              </div>
            ))
          )}
        </div>
      </Content>
      <div className='newsContainer'>
        <Newscontainer />
      </div>
      <MoreNews>
        <Title>Fique por dentro de tudo</Title>
        <div className="conteinerNews">
          {news?.slice(5, news.length)?.map((newsItem, index) => (
            <div
              key={index}
              className="newsItem"
              onClick={() => handleClick(newsItem.slug)}
            >
              <div className="leftItem">
                <h3>{newsItem.date_formatted}</h3>
                <h2> {decodeText(newsItem.title)}</h2>
                <span>{decodeText(newsItem.description)}</span>
              </div>
              <img src={httpTohttps(newsItem.image)} alt="news" />
            </div>
          ))}
          {isLoading &&
            [...Array(10)].map((item, index) => (
              <LoadingMoreNews key={index} />
            ))}
        </div>
        {enableShowMore && (
          <AlignButton>
            <Button className="showMore" onClick={handleShowMore}>
              Ver Mais
            </Button>
          </AlignButton>
        )}
      </MoreNews>
    </Container>
  );
};

export default News;
